import { render, staticRenderFns } from "./ExportExcel.vue?vue&type=template&id=496ab31a"
import script from "./ExportExcel.vue?vue&type=script&lang=js"
export * from "./ExportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports